<template>
  <div class="header-wrapper">
    <div class="up-wrapper">
      <div class="son">
        <a href="javascript:void(0);" @click.prevent="goHealthSite()" style="color: #fff">
          健康网
        </a>
        <div  class="login-wrapper"  @click="$router.push('/guide')">
          <span style="color: #fff" >服务指南</span>
        </div>

        <div class="after-login">
          <div class="after-son" v-show="islogin" @click="$router.push('/PersonalInfo')">
            <div class="img-wrapper">
              <img width="100%" :src="userInfo&&userInfo.head" />
            </div>
            <div class="name">{{userInfo&&userInfo.userName}}</div>
            <div class="grade">
              <img :src="userInfo&&userInfo.vipIcon" />
            </div>
          </div>
          <div
            class="message-icon"
            v-show="islogin"
            @click="$router.push('/PersonalSystem')"
          >
            <el-badge v-if="noReadMessage>0" is-dot class="item">
              <i class="el-icon-bell"></i>
            </el-badge>
            <el-badge v-else class="item">
              <i class="el-icon-bell"></i>
            </el-badge>
          </div>

          <div class="sign-out" v-show="islogin" @click="logoOut()">退出</div>
        </div>
        <div class="login-wrapper" v-show="!islogin">
          <span @click="loginAction() " class="line-border">登录</span>
          <!-- <el-divider direction="vertical"></el-divider> -->
          <span @click="openIamRegister()">注册</span>
        </div>
      </div>
    </div>
    <IamLoginModal
      :visible="dialogTableVisible"
      @close="closeDialog"
      @success="handleIamLoginSuccess"
    />
<div >
</div>
    <!-- 注册弹框 -->
    <el-dialog title="新用户注册" :visible.sync="registerVisible" width="400px" center>
      <div class="sign-wrapper">
        <el-form
          :model="logonForm"
          status-icon
          :rules="registerRules"
          ref="logonForm"
          class="demo-logonForm"
        >
          <el-form-item prop="phone">
            <el-input
              type="text"
              v-model="logonForm.phone"
              disableautocomplete
              autocomplete="off"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <div class="code-wrapper">
            <el-form-item prop="code">
              <el-input
                type="text"
                v-model="logonForm.code"
                disableautocomplete
                autocomplete="off"
                placeholder="请输入验证码"
              ></el-input>
            </el-form-item>
            <div class="code-button">
              <div class="send-code" @click="CationCode(logonForm)">{{countText}}</div>
              <div class="mask" v-if="codestatus"></div>
            </div>
          </div>
          <el-form-item prop="pass">
            <el-input
              type="password"
              v-model="logonForm.pass"
              disableautocomplete
              autocomplete="new-password"
              placeholder="请输入6-16位密码"
            ></el-input>
          </el-form-item>
          <el-form-item prop="passTwo">
            <el-input
              type="password"
              v-model="logonForm.passTwo"
              disableautocomplete
              autocomplete="new-password"
              placeholder="确认密码"
            ></el-input>
          </el-form-item>
          <el-form-item prop="clause">
            <el-checkbox v-model="logonForm.clause">同意服务条款、隐私政策</el-checkbox>
            <el-link type="primary" :underline="false" @click="$router.push('/clause')">前往隐私政策</el-link>
          </el-form-item>
          <div class="button-wrapper" @click="logonSubmitForm('logonForm')">注册</div>
          <div class="return-wrapper">
            <div class="son" @click="goLogin()">返回登录</div>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <!-- 忘记密码弹框 -->
    <el-dialog title="忘记密码" :visible.sync="forgetPwdVisible" width="400px" center>
      <div class="sign-wrapper">
        <el-form
          :model="forgetPwdForm"
          status-icon
          :rules="rules"
          ref="forgetPwdForm"
          class="demo-logonForm"
        >
          <el-form-item prop="phone">
            <el-input
              type="text"
              v-model="forgetPwdForm.phone"
              disableautocomplete
              autocomplete="off"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <div class="code-wrapper">
            <el-form-item prop="code">
              <el-input
                type="text"
                v-model="forgetPwdForm.code"
                disableautocomplete
                autocomplete="off"
                placeholder="请输入验证码"
              ></el-input>
            </el-form-item>
            <div class="code-button">
              <div class="send-code" @click="CationCode3(forgetPwdForm)">{{countText}}</div>
              <div class="mask" v-if="codestatus"></div>
            </div>
          </div>
          <el-form-item prop="pass">
            <el-input
              type="password"
              v-model="forgetPwdForm.pass"
              disableautocomplete
              autocomplete="new-password"
              placeholder="请输入6-16位密码"
            ></el-input>
          </el-form-item>
          <el-form-item prop="passTwo">
            <el-input
              type="password"
              v-model="forgetPwdForm.passTwo"
              disableautocomplete
              autocomplete="new-password"
              placeholder="确认密码"
            ></el-input>
          </el-form-item>
          <div class="button-wrapper" @click="forgetPwdSubmitForm('forgetPwdForm')">找回密码</div>
          <div class="return-wrapper">
            <div class="son" @click="goLogin()">返回登录</div>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Tabs from "@/common/tabs";
import Level from "@/common/level";
import IamLoginModal from "@/common/IamLoginModal";
import { mapState } from "vuex";
import { Loading } from "element-ui";

export default {
  data() {
    var validateUser = (rule, value, callback) => {
      console.log("user");
      if (value === "") {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };

    // 用户注册
    var validatePhone = (rule, value, callback) => {
      console.log("手机");
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!/^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    // 用户注册
    var validateRegisterPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!/^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        this.api.checkRegister({ phone: value }).then(res => {
          if (res == true) {
            callback();
          } else {
            callback("手机号已被注册");
          }
        });
      }
    };
    var validateCode = (rule, value, callback) => {
      console.log("验证码");
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        // if (this.logonForm.checkPass !== '') {
        //   this.$refs.logonForm.validateField('checkPass')
        // }
        callback();
      }
    };
    // 登录验证
    var validatePassLogin = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      }
      // ('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,30}')
      // else if (!/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,30}$/.test(value)) {
      //   callback(
      //     new Error("密码中必须包含大写字母、小写字母、数字、特殊字符")
      //   );
      // }
      else {
        callback();
      }
    };
    /* 注册忘记密码 密码验证 */
    /*var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (
        !/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,30}$/.test(
          value
        )
      ) {
        callback(new Error("密码中必须包含大写字母、小写字母、数字、特殊字符"));
      } else {
        callback();
      }
    }; */


    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (
       !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(
          value
        )
      ) {
        callback(new Error("密码中必须包含6-16位字母和数字组合"));
      } else {
        callback();
      }
    };



    var validatePassTwo = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请确认密码"));
      } else if (this.logonForm.passTwo !== this.logonForm.pass) {
        // if (this.ruleForm.passTwo !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致"));
        // }
      } else {
        callback();
      }
    };
    var validateClause = (rule, value, callback) => {
      if (value === "" || value === false) {
        callback(new Error("请选择服务条款、隐私政策"));
      } else {
        callback();
      }
    };
    return {
      noReadMessage: 0,
      // dialogTableVisible: false,
      registerVisible: false,
      forgetPwdVisible: false,
      count: 0,
      countText: "获取验证码",
      countText2: "获取验证码",
      codestatus: false,
      ruleForm: {
        user: "",
        code: "",
        passLogin: ""
      },
      logonPhoneForm: {
        phone: "",
        code: ""
      },
      logonForm: {
        phone: "",
        code: "",
        pass: "",
        passTwo: "",
        clause: false
      },
      forgetPwdForm: {
        phone: "",
        code: "",
        pass: "",
        passTwo: ""
      },
      rules: {
        user: [{ validator: validateUser, trigger: "blur", required: true }],
        phone: [{ validator: validatePhone, trigger: "blur", required: true }],
        code: [{ validator: validateCode, trigger: "blur", required: true }],
        passLogin: [
          { validator: validatePassLogin, trigger: "blur", required: true }
        ],
        pass: [{ validator: validatePass, trigger: "blur", required: true }],
        passTwo: [
          { validator: validatePassTwo, trigger: "blur", required: true }
        ]
      },
      registerRules: {
        user: [{ validator: validateUser, trigger: "blur", required: true }],
        phone: [
          { validator: validateRegisterPhone, trigger: "blur", required: true }
        ],
        code: [{ validator: validateCode, trigger: "blur", required: true }],
        passLogin: [
          { validator: validatePassLogin, trigger: "blur", required: true }
        ],
        pass: [{ validator: validatePass, trigger: "blur", required: true }],
        passTwo: [
          { validator: validatePassTwo, trigger: "blur", required: true }
        ],
        clause: [{ validator: validateClause, trigger: "blur" }]
      },
      z: 0,
      showCodelogin: false,
      logintypetxt: "手机号快捷登录",
      showcenter: false
    };
  },
  created() {},
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      islogin: state => state.islogin,
      dialogTableVisible: state => state.showLogin,
      downloadData: state => state.downloadData,
      queryData: state => state.queryData
    })
  },
  mounted() {
    this.loadMessageCount();
    if (this.$route.query && this.$route.query.openLogin === "1") {
      this.$store.commit("ChangeLoginStatus", true);
      this.$router.replace({
        path: this.$route.path,
        query: Object.assign({}, this.$route.query, { openLogin: undefined })
      });
    }
    // if(!localStorage.getItem('islogin')){
    //   this.registerVisible = false;
    // }
    // this.showcenter = this.islogin
  },
  methods: {
    loadMessageCount() {
      this.api
        .getMessageCount()
        .then(res => {
          this.noReadMessage = res.notReadCounts;
        })
        .catch(error => {});
    },
    handleIamLoginSuccess(userInfo) {
      this.$store.commit("SetuserInfo", userInfo);
      this.$store.commit("ChangeLoginStatus", false);
      this.loadMessageCount();
      this.submitOrder();
    },
    forgotPass() {
      this.forgetPwdVisible = true;
      // this.dialogTableVisible = false;
      this.$store.commit("ChangeLoginStatus", false);
    },
    loginWechatFun() {
      var params = this.$route.query;
      var paramsStr = "";
      for (var key in params) {
        paramsStr = paramsStr + "@" + key + "=" + params[key];
        console.log(key, params[key]);
      }
      // debugger;
      window.open(
        this.api.wechat() + "?url=" + this.$route.path + "~" + paramsStr,
        "_self"
      );
    },
    loginQqFun() {
      console.log("qq登录");
      window.open(this.api.qq(), "_self");
    },
    loginWeiboFun() {
      console.log("微博登录");
      window.open(this.api.weibo(), "_self");
    },
    //登录
    loginAction() {
      // this.dialogTableVisible = true;
      this.$store.commit("ChangeLoginStatus", true);
    },

    //退出
    async logoOut() {
      this.$message({
        message: "退出登录成功",
        type: "success"
      });
      try {
        var frame = window.__bridgeFrame;
        if (frame && frame.contentWindow) {
          frame.contentWindow.postMessage({ action: "sso-clear", tokenKey: "sysdbToken" }, "*");
        }
      } catch (e) {
      }
      try {
        sessionStorage.setItem("ssoAutoSuppressed", "true");
      } catch (e) {
      }
      this.$store.commit("SetuserInfo", {});
      this.$store.commit("ChangeIslogin", false);
      localStorage.removeItem("token");
      localStorage.removeItem("sign");
      localStorage.removeItem("authToken");
      localStorage.removeItem("authGk");
      localStorage.removeItem("dmiToken");
      this.showcenter = false;
      this.$router.push("/");
      this.$store.commit("SetQueryData", {});
      this.$store.commit("SaveDownloadData", {});
      window.location.reload();
    },
    goRegister() {
      this.openIamRegister();
    },
    getRuntimeConfig() {
      console.log(cfg)
      if (typeof cfg !== "undefined") {
        return cfg;
      }
      return {};
    },
    resolveAuthLoginOrigin() {
      var runtimeConfig = this.getRuntimeConfig();
      if (runtimeConfig.authLoginOrigin) {
        return runtimeConfig.authLoginOrigin.replace(/\/$/, "");
      }
      if (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
      ) {
        return "http://127.0.0.1:3321";
      }
      return window.location.origin;
    },
    resolveRegisterBaseUrl(loginPageUrl) {
      if (loginPageUrl) {
        try {
          var loginUrl = new URL(loginPageUrl, window.location.origin);
          return loginUrl.origin + "/authLogin/RegisterMain";
        } catch (error) {}
      }
      return this.resolveAuthLoginOrigin() + "/authLogin/RegisterMain";
    },
    goHealthSite() {
      var curCrossKey = localStorage.getItem("crossKey");
      var url = "https://www.healthoo.com/";
      if (curCrossKey) {
        url += "?crossKey=" + encodeURIComponent(curCrossKey);
      }
      window.open(url, "_blank");
    },
    openIamRegister() {
      var runtimeConfig = this.getRuntimeConfig();
      var returnUrl = new URL(
        (runtimeConfig.appBase || "/"),
        window.location.origin
      ).toString();

      this.api
        .getSsoLoginUrl()
        .then(res => {
          if (!(res && (res.code === 200 || res.error === 0) && res.data)) {
            this.$message.error((res && (res.msg || res.message)) || "获取注册参数失败");
            return;
          }

          var registerUrl = new URL(
            this.resolveRegisterBaseUrl(res.data.loginPageUrl)
          );
          registerUrl.searchParams.append("source", "db");
          registerUrl.searchParams.append("returnUrl", returnUrl);
          if (res.data.authUrl) {
            registerUrl.searchParams.append("authUrl", res.data.authUrl);
          }
          if (res.data.clientId) {
            registerUrl.searchParams.append("clientId", res.data.clientId);
          }
          if (res.data.callbackUrl) {
            registerUrl.searchParams.append("callbackUrl", res.data.callbackUrl);
          }
          if (res.data.state) {
            registerUrl.searchParams.append("state", res.data.state);
          }
          registerUrl.searchParams.append("_t", Date.now());
          window.open(registerUrl.toString(), "_blank");
        })
        .catch(error => {
          this.$message.error(error || "获取注册参数失败");
        });
    },
    goLogin() {
      // this.dialogTableVisible = true;
      this.registerVisible = false;
      this.forgetPwdVisible = false;
      this.$store.commit("ChangeLoginStatus", true);
    },
    closeDialog() {
      this.$store.commit("ChangeLoginStatus", false);
    },
    //切换登录
    loginSwitch() {
      this.showCodelogin = !this.showCodelogin;
      if (this.showCodelogin == false) {
        this.logintypetxt = "手机号快捷登录";
      } else {
        this.logintypetxt = "账号密码登录";
      }
      //this.showCodelogin==false?this.logintypetxt = '手机号快捷登录':this.logintypetxt = '账号密码登录'
    },
    //发送验证码
    sendCode(phone, type) {
      let dataobj = {
        phone: phone,
        type: type
      };
      this.api
        .sendCode(dataobj)
        .then(res => {
          console.log("验证码请求：", res);
          if (res.length) {
            //返回文字
            this.$message.error(res);
          } else {
            this.$message({
              message: "验证码发送成功，请注意查收",
              type: "success"
            });
            // debugger;
            this.count = 60;
            this.codestatus = true;
            let time = setInterval(() => {
              if (this.count <= 0) {
                clearInterval(time);
                this.codestatus = false;
                this.countText = "获取验证码";
              } else {
                this.count = this.count - 1;
                this.countText = `还剩${this.count}秒`;
              }
            }, 1000);
          }
        })
        .catch(error => {});
    },
    CationCode2(logonPhoneForm) {
      console.log("滑块验证码...")

      this.$refs.logonPhoneForm.validateField("phone", valid => {
        if (!valid) {
          this.sendCode(this.logonPhoneForm.phone, 1);
          this.count = 60;
          this.codestatus = true;
          let time = setInterval(() => {
            if (this.count <= 0) {
              clearInterval(time);
              this.codestatus = false;
              this.countText2 = "获取验证码";
            } else {
              this.count = this.count - 1;
              this.countText2 = `还剩${this.count}秒`;
            }
          }, 1000);
        } else {
          return false;
        }
      });
    },
    // 注册获取验证码
    CationCode(logonForm) {
      this.$refs.logonForm.validateField("phone", valid => {
        if (!valid) {
          this.sendCode(this.logonForm.phone, 2);
        } else {
          return false;
        }
      });
    },
    // 忘记密码获取验证码
    CationCode3(logonForm) {
      this.$refs.forgetPwdForm.validateField("phone", valid => {
        if (!valid) {
          if (this.sendCode(this.forgetPwdForm.phone, 3)) {
            this.count = 60;
            this.codestatus = true;
            let time = setInterval(() => {
              if (this.count <= 0) {
                clearInterval(time);
                this.codestatus = false;
                this.countText = "获取验证码";
              } else {
                this.count = this.count - 1;
                this.countText = `还剩${this.count}秒`;
              }
            }, 1000);
          }
        } else {
          return false;
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          // console.log('error submit!!')
          this.api
            .register()
            .then(res => {})
            .catch(err => {
              console.log(err);
            });
          return false;
        }
      });
    },
    logonSubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //alert("submit!");
          this.api
            .register({
              phone: this.logonForm.phone,
              code: this.logonForm.code,
              password: this.logonForm.pass,
              surePassword: this.logonForm.passTwo
            })
            .then(res => {
              this.$message({
                message: "注册成功",
                type: "success"
              });
              this.registerVisible = false;
              this.loginAction();
            })
            .catch(err => {
              console.log(err);
              this.$message.error(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    forgetPwdSubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //alert("submit!");
          this.api
            .forgetPassword({
              phone: this.forgetPwdForm.phone,
              code: this.forgetPwdForm.code,
              password: this.forgetPwdForm.pass,
              surePassword: this.forgetPwdForm.passTwo
            })
            .then(res => {
              this.$message({
                message: "找回密码成功",
                type: "success"
              });
              console.log(res);
              this.forgetPwdVisible = false;
              this.loginAction();
            })
            .catch(err => {
              console.log(err);
              this.$message.error(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //登录
    registerSubmitForm(formName) {
      let _this = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          let postdata = {
            phone: this.ruleForm.user,
            password: this.ruleForm.passLogin
          };
          let phonedata = {
            phone: this.logonPhoneForm.phone,
            code: Number(this.logonPhoneForm.code)
          };

          //let storageobj = {}
          if (this.showCodelogin == false) {
            // 账号密码登录
            this.api
              .userLogin(postdata)
              .then(res => {
                this.$message({
                  message: "登录成功",
                  type: "success"
                });
                _this.$store.commit("SetuserInfo", res);
                localStorage.setItem("token", res.token);
                localStorage.removeItem("dmiToken");
                _this.$store.commit("ChangeLoginStatus", false);
              })
              .then(function() {
                _this.submitOrder();
              })
              .catch(error => {
                this.$message.error(error);
              });
          } else {
            // 手机快捷登录
            this.api
              .phoneLogin(phonedata)
              .then(res => {
                this.$message({
                  message: "登录成功",
                  type: "success"
                });
                _this.$store.commit("SetuserInfo", res);
                localStorage.setItem("token", res.token);
                localStorage.removeItem("dmiToken");
                _this.$store.commit("ChangeLoginStatus", false);
              })
              .then(function() {
                _this.submitOrder();
              })
              .catch(error => {
                this.$message.error(error);
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //提交订单
    submitOrder() {
      console.log("进入提交订单方法，还未提交");
      // 下载文件或者下载数据有数据时
      if (this.downloadData) {
        console.log("存在订单数据");
        if(this.downloadData.orderType==4||this.downloadData.orderType==2){
            this.api
                .createOrder(this.downloadData)
                .then(res => {
                    console.log(res);
                    let routeData = this.$router.resolve({
                        path: "/ShoppingCart",
                        query: {
                            orderno: res.orderNo
                        }
                    });
                    window.open(routeData.href, "_blank");
                })
                .catch(error => {
                    console.log(error);
                    this.$message.error("服务器出了小差，请重新搜索数据");
                });
        }else{
            this.api.pageSearch(this.queryData).then(res => {
                // orderType == 2 下载文件 orderType == 1 下载数据
                if (
                    (this.downloadData.fileIds && this.downloadData.orderType == 2) ||
                    (this.downloadData.downloadColumn &&
                        this.downloadData.orderType == 1)|| (
                    this.downloadData.orderType == 4)
                ) {
                    this.api
                        .createOrder(this.downloadData)
                        .then(res => {
                            console.log(res);
                            let routeData = this.$router.resolve({
                                path: "/ShoppingCart",
                                query: {
                                    orderno: res.orderNo
                                }
                            });
                            window.open(routeData.href, "_blank");
                        })
                        .catch(error => {
                            console.log(error);
                            this.$message.error("服务器出了小差，请重新搜索数据");
                        });
                } else {
                    console.tablelog("不满足订单创建条件");
                }
            });
        }

      }else{
          this.$router.go(0);
      }
    },
    //获取token
    getToken(data) {
      console.log("获取token方法");
      let postdata = {
        credenceUnique: data
      };
      this.api
        .getToken(postdata)
        .then(res => {
          localStorage.setItem("token", res.token);
          localStorage.setItem("sign", res.sign);
          localStorage.removeItem("dmiToken");
        })
        .catch(error => {});
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  components: {
    Tabs,
    Level,
    IamLoginModal
  }
};
</script>
<style lang="less" scoped>
@import "../styles/size.less";
.message-icon {
  font-size: 20px;
  color: @white;
}
.item {
  margin-top: 3px;
  margin-left: 10px;
}
.el-checkbox {
  font-weight: 200;
  font-size: 13px;
}
.el-checkbox__label {
  font-size: 13px;
  color: @header;
}
.el-form-item__content {
  line-height: 0px;
}
.el-link.el-link--primary {
  color: @header;
}
.el-checkbox__input is-checked {
  color: @header;
}
.header-wrapper {
  width: 100%;
  .up-wrapper {
    height: 45px;
    background: @header;
    //background: #00a8ff;
    box-sizing: border-box;
    .son {
      width: 1200px;
      height: 100%;
      /*border: 1px solid red;*/
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .el-dropdown-link {
        cursor: pointer;
        color: @white;
      }
      .after-login {
        display: flex;
        align-items: center;
        margin: 0 0 0 35px;
        /*border: 1px solid red;*/
        .after-son {
          display: flex;
          align-items: center;
          cursor: pointer;
          .img-wrapper {
            width: 25px;
            height: 25px;

            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
          .grade {
            width: 28px;
            height: 24px;
            img {
              width: 100%;
            }
          }
          .name {
            color: @white;
            margin: 0 5px;
          }
        }

        .sign-out {
          color: @white;
          margin: 0 0 0 30px;
          cursor: pointer;
        }
      }
      .login-wrapper {
        /*border: 1px solid red;*/
        margin: 0 0 0 35px;
        color: @white;
        span {
          cursor: pointer;
        }
        .line-border:after {
          content: "|";
          margin-left: 4px;
        }
      }
      .el-icon-arrow-down {
        font-size: @s-14;
        line-height: @s-14;
      }
    }
  }
  .sign-wrapper {
    /*border: 1px solid red;*/
    padding: 0 5px;
    .demo-logonForm {
      .input-err {
        input {
          border: 1px solid red !important;
        }
      }
    }
    .quick-wrapper {
      display: flex;
      justify-content: space-between;
      margin: 0 0 10px 0;
      .quick-son {
        color: @theme-color;
        cursor: pointer;
      }
      .cipher-wrapper {
        color: @e60012;
        span {
          cursor: pointer;
        }
      }
    }
    .button-wrapper {
      width: 100%;
      height: 40px;
      background: @theme-color;
      border-radius: 3px;
      color: @white;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: 10px;
      cursor: pointer;
    }
    .third-party {
      /*border: 1px solid blue;*/
      margin: 20px auto 0;
      display: flex;
      justify-content: center;
      .qq,
      .wechat,
      .sina {
        width: 40px;
        height: 40px;
        // margin: 0 0 0 40px;
        .iconfont {
          font-size: @s-40;
          line-height: @s-40;
        }
      }
      .qq {
        margin: 0;
        color: #1e9cf0;
      }
      .wechat {
        color: #3eb135;
      }
      .sina {
        color: #df4d69;
      }
    }

    .code-wrapper {
      /*border: 1px solid red;*/
      display: flex;
      justify-content: space-between;
      .code-button {
        width: 116px;
        height: 40px;
        border: 1px solid @dfdfdf;
        box-sizing: border-box;
        border-radius: 3px;
        margin: 1px 0 0 0;
        position: relative;
        color: @999;
        .send-code {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          /*border: 1px solid blue;*/
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          z-index: 1;
        }
        .mask {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          /*border: 1px solid green;*/
          z-index: 2;
        }
      }
    }
    .return-wrapper {
      display: flex;
      justify-content: flex-end;
      margin: 20px 0 0 0;
      .son {
        color: @theme-color;
        cursor: pointer;
      }
    }
  }
}
</style>
<!-- <style type="text/css">
  .input-err input {
    border: 1px solid red;
  }
</style> -->



// WEBPACK FOOTER //
// src/common/header.vue